import React from 'react'

interface LogoProps {
  width?: number | string
  height?: number | string
  className?: string
}

const Logo: React.FC<LogoProps> = ({ width = 65, height = 21, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 65 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M48.7101 20.43C44.6591 20.4717 41.3396 17.1383 41.2891 12.9781C41.3396 8.81797 44.6591 5.48461 48.7101 5.52627C52.761 5.48461 56.0805 8.81797 56.1311 12.9781C56.1305 13.2475 56.1162 13.5166 56.0881 13.7843H44.7551C45.0584 15.8522 46.775 17.3904 48.8111 17.4189C50.3109 17.4041 51.6831 16.5494 52.3891 15.1903L55.5891 15.7675C54.4306 18.6119 51.7122 20.4545 48.7101 20.43ZM48.8101 8.61958C47.0946 8.63014 45.5668 9.73649 44.9811 11.3925H52.6401C52.053 9.7372 50.5263 8.63079 48.8111 8.61752L48.8101 8.61958Z"
        fill="#005FB3"
      />
      <path d="M35.5071 20.1619H39.2941V5.83838H35.5071V20.1619Z" fill="#005FB3" />
      <path
        d="M37.4 9.70454e-07C36.2339 0.00113608 35.2893 0.972739 35.29 2.17038C35.2908 3.36803 36.2365 4.33841 37.4027 4.33803C38.5689 4.33765 39.514 3.36666 39.514 2.16902C39.514 1.5934 39.2913 1.04139 38.8947 0.634565C38.4982 0.227737 37.9605 -0.000543142 37.4 9.70454e-07Z"
        fill="#005FB3"
      />
      <path
        d="M12.312 1.24561V8.95629H4.144V1.24561H0V20.1495H4.144V12.4399H12.312V20.1505H16.456V1.24561H12.312Z"
        fill="#005FB3"
      />
      <path
        d="M25.64 20.4258C22.5725 20.4224 19.8389 18.4372 18.8132 15.4682C17.7876 12.4992 18.6919 9.18854 21.0715 7.20052C23.4512 5.21251 26.7913 4.97715 29.413 6.61276V5.84251H33.025V20.1506H29.325V19.3989C28.2076 20.0718 26.9355 20.4263 25.64 20.4258ZM25.825 8.67494C23.5139 8.6993 21.6574 10.6388 21.6731 13.0124C21.6889 15.3859 23.571 17.2992 25.8822 17.2912C28.1934 17.2832 30.0629 15.3568 30.063 12.9832C30.0471 10.5934 28.1521 8.66699 25.825 8.67494Z"
        fill="#005FB3"
      />
      <path
        d="M63.965 4.50537C60.4152 5.15596 57.8187 8.3087 57.783 12.0117V20.1609H61.41V11.8587C61.4096 9.97871 62.7734 8.39316 64.59 8.16147L63.965 4.50537Z"
        fill="#005FB3"
      />
    </svg>
  )
}

export default Logo

